import React from "react";
import styled from "styled-components";
import Button from "../../../components/Button";

const HeroContainer = styled.div`
  background: url("https://res.cloudinary.com/dodieozgh/image/upload/v1667850718/realcars/hero_sskh0u.jpg")
    center/cover no-repeat var(--black);
  height: 100vh;
  width: 100%;
  display: flex;
  @media (max-width: 992px) {
    background: url("https://res.cloudinary.com/dodieozgh/image/upload/v1667402102/realcars/hero-responsive_vtshz5.jpg")
      center/cover no-repeat;
  }
`;

const InfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  padding: 0 60px;
  gap: 20px;
  @media (max-width: 576px) {
    padding: 0px 30px;
  }
`;

const HeroTitle = styled.h1`
  color: var(--white);
  font-size: 3rem;
  font-family: var(--roboto);
  span {
    color: var(--red);
  }
  @media screen and (max-width: 576px) {
    display: flex;
    flex-direction: column;
  }
  @media (max-width: 400px) {
    font-size: 2.5rem;
  }
  @media (min-width: 1300px) {
    font-size: 3.5rem;
  }
`;

const HeroP = styled.p`
  color: var(--white);
  width: 60%;
  font-size: 1rem;
  font-family: var(--raleway);
  margin-left: 1px;

  @media screen and (max-width: 576px) {
    width: 100%;
  }
  @media (min-width: 1300px) {
    font-size: 1.1rem;
  }
`;

const Alquiler = styled.span`
  color: var(--white);
  font-size: 0.7rem;
  font-family: var(--roboto);
  font-weight: 200;
  letter-spacing: 2px;
  margin-left: 3px;
  @media (min-width: 1300px) {
    font-size: 1rem;
  }
`;

const TitleContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
`;

const Hero = () => {
  return (
    <>
      <HeroContainer>
        <InfoContainer data-aos="fade-right" data-aos-delay="200">
          <TitleContainer>
            <Alquiler>Alquiler de autos</Alquiler>
            <HeroTitle>
              SOMOS <span>REAL CARS</span>
            </HeroTitle>
          </TitleContainer>
          <HeroP>
            Te ofrecemos la posibilidad de contar con movilidad propia de forma
            fácil, segura y accesible.
          </HeroP>
          <Button path="/contacto" text="Contactanos"></Button>
        </InfoContainer>
      </HeroContainer>
    </>
  );
};

export default Hero;
